import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { usePermissions } from "hooks/general-hooks";

const NoConsent = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [prevLocation] = useState(location.state.prevLocation);
  const [permissions, setPermissions] = usePermissions();

  useEffect(() => {
    setPermissions({
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
    });
    history.replace({
      pathname: prevLocation.pathname,
      search: prevLocation.search,
    });
    window.location.reload();
  }, []);

  return <div id="quantcast-cmp"></div>;
};

export default NoConsent;
